module.exports = __webpack_public_path__ + "assets/img/2018_5.90fb8b0b.png";